<script lang="ts">
  import { clic } from '../../directives/actions.svelte';
  import type { ReferentielSelectionne } from '../exigence.type';
  import { exigencesFiltrees } from '../stores/exigencesFiltrees.store';

  type Props = {
    langueSelectionnee: 'FR' | 'EN';
    sensComparaison: 'NIS2_VERS_CIBLE' | 'SOURCE_VERS_NIS2';
    referentielSelectionne: ReferentielSelectionne | '';
  };
  let {
    langueSelectionnee = $bindable('FR'),
    sensComparaison = $bindable(),
    referentielSelectionne = $bindable(),
  }: Props = $props();

  const reinitialise = async () => {
    referentielSelectionne = '';
    sensComparaison = 'NIS2_VERS_CIBLE';
    langueSelectionnee = 'FR';
    $exigencesFiltrees.reinitialise();
  };
</script>

{#if langueSelectionnee !== 'FR' || referentielSelectionne || sensComparaison !== 'NIS2_VERS_CIBLE' || $exigencesFiltrees.filtresActifs}
  <dsfr-button
    label="Réinitialiser"
    has-icon="true"
    icon-place="left"
    icon="close-circle-line"
    kind="tertiary"
    use:clic={reinitialise}
  ></dsfr-button>
{/if}
